import React from 'react'
import { NoNotificationIcon } from '../../../../shared/IconsComponent/icons'
const AllNotifications = () => {
    return (
        <div>
            <div className="d-flex align-items-center justify-content-center flex-column gap-12 py-3 my-1">
                <NoNotificationIcon classes={'fs-48'} />
                {/* Task No Notification design  */}
                <div className="text-center">
                    <p className='text fs-12 font-m'>No New Notifications!</p>
                    <p className='text fs-11 ar-ligh-color'>We’ll notify you once something comes up.</p>
                </div>
            </div>
            {/* <div className="d-flex flex-column gap-10 px-10 scroll pb-2 px-10">
                <div className="ar-content">
                    <div className="ar-header d-flex justify-content-between align-items-center">
                        <p className="text font-m d-flex gap-1 align-items-center pb-1">You have a new task</p>
                        <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                    </div>
                    <p className="text fs-10 fst-italic ar-light-color">Just now</p>
                </div>
                <div className="ar-content">
                    <div className="ar-header d-flex justify-content-between align-items-center">
                        <p className="text font-m d-flex gap-1 align-items-center pb-1">New message from Naomi</p>
                        <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                    </div>
                    <p className="text fs-10 fst-italic ar-light-color">2 hours ago</p>
                </div>
                <div className="ar-content">
                    <div className="ar-header d-flex justify-content-between align-items-center">
                        <p className="text font-m d-flex gap-1 align-items-center pb-1">New message from Naomi</p>
                        <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                    </div>
                    <p className="text fs-10 fst-italic ar-light-color">2 hours ago</p>
                </div>
                <div className="ar-content">
                    <div className="ar-header d-flex justify-content-between align-items-center">
                        <p className="text font-m d-flex gap-1 align-items-center pb-1">New message from Naomi</p>
                        <i className="fs-10 icon-Icon-metro-cross opacity-0"></i>
                    </div>
                    <p className="text fs-10 fst-italic ar-light-color">2 hours ago</p>
                </div>
            </div>
            <div className="px-10 d-flex align-items-center justify-content-end ar-footer gap-1">
                <i className="bi bi-check-all fs-18"></i>
                <p className="text fs-11 cursor-pointer">Mark All as read</p>
            </div> */}
        </div>
    )
}

export default AllNotifications